


























import { REASONS } from "@/resources/constants/busyReasons";
import { i18n } from "@/resources/locales";
import NotificationEvent from "@/resources/mixins/notifications/notificationEvent";
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";
@Component({
  name: "vacation-modal-component",
})
export default class VacationModalComponent extends mixins(NotificationEvent) {
  REASONS = REASONS;
  date = "";
  get active(): boolean {
    return this.$store.getters["SystemStore/getVacationModal"];
  }
  set active(e) {
    this.$store.dispatch("SystemStore/setVacationModalAction", e);
  }
  sendVacation(): void {
    if (this.date != "") {
      const spaceUser = this.$store.getters["UserStore/getSpaceUser"];
      this.$store.dispatch("UserStore/updateUserStatusAction", {
        userId: spaceUser.superSpaceUser.user.id,
        props: {
          availableStatus: "RED",
          availableStatusReason: this.REASONS.filter((a) => a.id === 7)[0].type,
          emoji: this.REASONS.filter((a) => a.id === 7)[0].code,
          vacationsEnd: this.date,
        },
        callback: (user) => {
          this.$store.dispatch("SpaceStore/updateUserInSpace", user);
          this.active = false;
          this.onSuccess(
            i18n.t("notifications.titles.success"),
            i18n.t("notifications.descriptions.vacationOn")
          );
        },
        callbackError: (error) => {
          this.active = false;
          this.$vs.notification({
            title: i18n.t("notifications.titles.error"),
            text: i18n.t("notifications.genericError.genericErrorRetry"),
          });
        },
      });
    } else {
      this.onError("", i18n.t("vacationModal.error"));
    }
  }
}
